import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
import { ShowcaseLogo } from './ShowcaseLogo';
const navItems = [{
  to: '/',
  label: 'Home'
}, {
  to: '/model-homes',
  label: 'Model Homes'
}, {
  to: '/magazine',
  label: 'Magazine'
}, {
  to: '/articles',
  label: 'Articles'
}, {
  to: '/visit',
  label: 'Visit & Contact'
}];
export function SiteHeader() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  useEffect(() => setOpen(false), [location.pathname]);
  return <header className="sticky top-0 z-40 border-b border-line bg-white/95 backdrop-blur" data-id="element-135" data-mp="14uc09hkgx08p">
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-5 lg:px-8" data-id="element-136" data-mp="zw0pn4mcmlpf">
        <Link to="/" className="rounded focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-navy" data-id="element-137" data-mp="2ga0qqiwxkhe9">
          <ShowcaseLogo data-id="element-138" data-mp="2belajkbga9eo" />
        </Link>

        <nav aria-label="Main" className="hidden items-center gap-1 lg:flex" data-id="element-139" data-mp="29kbspi7uaqq4">
          {navItems.map(item => <NavLink key={item.to} to={item.to} end={item.to === '/'} className={({
          isActive
        }) => `whitespace-nowrap rounded-md px-3.5 py-2 text-[15px] font-medium transition-colors duration-150 ${isActive ? 'bg-navy-light text-navy' : 'text-ink hover:bg-canvas hover:text-navy'}`} data-id="element-140" data-mp="2ehvj1ghtatyf">
              {item.label}
            </NavLink>)}
          <Link to="/model-homes" className="ml-3 whitespace-nowrap rounded-md bg-orange-deep px-4 py-2.5 text-[15px] font-semibold text-white transition-colors duration-150 hover:bg-orange-deeper" data-id="element-141" data-mp="20qyq1ojz4aqu">
            Tour map
          </Link>
        </nav>

        <button type="button" className="inline-flex h-11 w-11 items-center justify-center rounded-md text-navy hover:bg-canvas lg:hidden" aria-expanded={open} aria-controls="mobile-nav" aria-label={open ? 'Close menu' : 'Open menu'} onClick={() => setOpen(v => !v)} data-id="element-142" data-mp="1d1nxuvgovoob">
          {open ? <XIcon className="h-6 w-6" data-id="element-143" data-mp="1eqi021jal8s1" /> : <MenuIcon className="h-6 w-6" data-id="element-144" data-mp="1esvqty6xvyts" />}
        </button>
      </div>

      <AnimatePresence data-id="element-145" data-mp="19sgg7ee1l5fi">
        {open && <motion.nav id="mobile-nav" aria-label="Mobile" initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -8
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="border-t border-line bg-white px-5 pb-6 pt-3 lg:hidden" data-id="element-146" data-mp="m23zpf4qe0db">
            <ul className="flex flex-col" data-id="element-147" data-mp="r3jnvg27gmzx">
              {navItems.map(item => <li key={item.to} data-id="element-148" data-mp="27dvotccu6y12">
                  <NavLink to={item.to} end={item.to === '/'} className={({
              isActive
            }) => `block rounded-md px-3 py-3 text-lg font-medium ${isActive ? 'bg-navy-light text-navy' : 'text-ink'}`} data-id="element-149" data-mp="22glzrxtd0odr">
                    {item.label}
                  </NavLink>
                </li>)}
            </ul>
            <Link to="/model-homes" className="mt-4 block rounded-md bg-orange-deep px-4 py-3.5 text-center text-base font-semibold text-white" data-id="element-150" data-mp="2523929r2hunj">
              View the tour map
            </Link>
          </motion.nav>}
      </AnimatePresence>
    </header>;
}